import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { ContentSection } from "../../../sharedComponents/ContentSection";
import { Row, Cell } from "../../Grid/Grid";
import { Icon } from "../../Icons";
import * as styles from "./InfoGrid.module.scss";

const InfoGrid = ({ details, footer }) => {
	const detail1 = details.slice(0, 5);
	const detail2 = details.slice(5, 7);
	return (
		<div className={styles.container}>
			<Row cols="2">
				<Cell>
					<div>
						{detail1.map(item => (
							<ContentSection className={styles.questionContainer} key={item.id}>
								<ContentSection.Title className={styles.question}>
									{item.heading}
								</ContentSection.Title>
								<ContentSection.Content content={item.content} />
							</ContentSection>
						))}
					</div>
				</Cell>
				<Cell>
					{detail2.map(item => (
						<ContentSection className={styles.questionContainer} key={item.id}>
							<ContentSection.Title className={styles.question}>
								{item.heading}
							</ContentSection.Title>
							<ContentSection.Content content={item.content} />
						</ContentSection>
					))}
					<ContentSection className={styles.tipContainer}>
						<ContentSection.Title className={cx(styles.question, styles.tipQuestion)}>
							<Icon name="tip" className={styles.tipQuestionIcon} />
							{footer.heading}
						</ContentSection.Title>
						<ContentSection.Content content={footer.content} />
					</ContentSection>
				</Cell>
			</Row>
		</div>
	);
};

InfoGrid.propTypes = {
	details: PropTypes.arrayOf(
		PropTypes.shape({
			heading: PropTypes.string,
			content: PropTypes.object,
		})
	).isRequired,
	footer: PropTypes.shape({
		heading: PropTypes.string,
		content: PropTypes.object,
	}).isRequired,
};

export default InfoGrid;
export { InfoGrid };
